<div *ngIf="!isHidden" class="bg-base-200 border-t border-base-300 text-base-content transition-colors">
  <div class="max-w-7xl mx-auto px-4 py-16">

    @if (!isDefaultTenant || isAppMode) {
      <!-- ── App Mode / Custom Tenant: Simplified academy footer ── -->
      <div class="flex flex-col items-center text-center gap-4">
        <div class="flex items-center">
          @if (tenantLogoUrl) {
            <img [src]="tenantLogoUrl" [alt]="currentTenant?.name || 'Academy Logo'" class="h-10 max-w-[220px] object-contain" />
          } @else {
            <p class="text-lg font-bold text-base-content">{{ currentTenant?.name || 'Academy' }}</p>
          }
        </div>
        <p class="text-sm text-base-content/70">&copy; {{ currentTenant?.name || 'Academy' }}. All rights reserved.</p>
        <div class="flex flex-wrap items-center justify-center gap-4 text-sm text-base-content/70">
          <a routerLink="/terms" class="hover:text-primary transition-colors">Terms and Conditions</a>
          <span class="text-base-content/20">|</span>
          <a routerLink="/privacy" class="hover:text-primary transition-colors">Privacy Policy</a>
          <span class="text-base-content/20">|</span>
          <a routerLink="/refund" class="hover:text-primary transition-colors">Refund Policy</a>
        </div>
      </div>
    } @else {
      <!-- ── Platform Mode: Full marketing footer ── -->
      <div class="grid grid-cols-1 md:grid-cols-12 gap-x-8 gap-y-12">
        <!-- Logo and Copyright Section -->
        <div class="md:col-span-3">
          <div class="flex items-center">
            @if (tenantLogoUrl) {
              <img [src]="tenantLogoUrl" [alt]="currentTenant?.name || 'Academy Logo'" class="h-10 max-w-[220px] object-contain" />
            } @else {
              <img src="assets/images/logo.png" alt="Learnbird Logo" class="h-10" />
            }
          </div>
          <div class="mt-4 space-y-2 text-sm text-base-content/70">
            <p>&copy; 2026 CEYBYTE (Pvt) Ltd. All rights reserved.</p>
            <address class="not-italic">
              <span class="font-medium text-base-content/80">Contact:</span>
              <a
                href="mailto:info@ceybyte.lk"
                class="ml-1 text-base-content/70 hover:text-primary hover:underline underline-offset-2 transition-colors"
              >
                info&#64;ceybyte.lk</a
              >
            </address>
          </div>
        </div>

        <!-- Products Column -->
        <div class="md:col-span-2">
          <h3 class="text-base font-bold text-base-content mb-4">Products</h3>
          <ul class="space-y-3 text-sm">
            <li>
              <a
                routerLink="/live-classes"
                routerLinkActive="router-link-active"
                class="text-base-content/70 hover:text-primary transition-colors"
                >Live Classes</a
              >
            </li>
            <li>
              <a
                routerLink="/auth/login"
                class="text-base-content/70 hover:text-primary transition-colors"
                >Log in</a
              >
            </li>
            <li>
              <a
                routerLink="/auth/register"
                class="text-base-content/70 hover:text-primary transition-colors"
                >Sign up</a
              >
            </li>
            <li>
              <a
                routerLink="/teach"
                class="text-base-content/70 hover:text-primary transition-colors"
                >Teach on Learnbird</a
              >
            </li>
            <li>
              <a
                routerLink="/auth/register"
                [queryParams]="{ role: 'instructor' }"
                class="text-base-content/70 hover:text-primary transition-colors"
                >Partnerships</a
              >
            </li>
          </ul>
        </div>

        <!-- About us Column -->
        <div class="md:col-span-2">
          <h3 class="text-base font-bold text-base-content mb-4">About us</h3>
          <ul class="space-y-3 text-sm">
            <li>
              <a href="#" class="text-base-content/70 hover:text-primary transition-colors"
                >About Learnbird</a
              >
            </li>
            <li>
              <a routerLink="/contact" class="text-base-content/70 hover:text-primary transition-colors"
                >Contact us</a
              >
            </li>
            <li>
              <a href="#" class="text-base-content/70 hover:text-primary transition-colors">Features</a>
            </li>
            <li>
              <a routerLink="/contact" class="text-base-content/70 hover:text-primary transition-colors"
                >Careers</a
              >
            </li>
          </ul>
        </div>

        <!-- Resources Column -->
        <div class="md:col-span-2">
          <h3 class="text-base font-bold text-base-content mb-4">Resources</h3>
          <ul class="space-y-3 text-sm">
            <li>
              <a routerLink="/contact" class="text-base-content/70 hover:text-primary transition-colors"
                >Help center</a
              >
            </li>
            <li>
              <a routerLink="/contact" class="text-base-content/70 hover:text-primary transition-colors"
                >Book a demo</a
              >
            </li>
          </ul>
        </div>

        <!-- Get in touch Column -->
        <div class="md:col-span-3">
          <h3 class="text-base font-bold text-base-content mb-4">Get in touch</h3>
          <p class="text-sm text-base-content/70 mb-6">
            Questions or feedback?<br />We'd love to hear from you
          </p>
          <!-- Social Links -->
          <div class="flex gap-4 text-lg">
            <a href="#" class="text-base-content/60 hover:text-primary transition-colors" aria-label="Facebook">
              <i class="fa-brands fa-facebook"></i>
            </a>
            <a href="#" class="text-base-content/60 hover:text-primary transition-colors" aria-label="Twitter">
              <i class="fa-brands fa-twitter"></i>
            </a>
            <a href="#" class="text-base-content/60 hover:text-primary transition-colors" aria-label="LinkedIn">
              <i class="fa-brands fa-linkedin"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Bottom Links -->
      <div
        class="flex flex-wrap items-center gap-4 mt-8 pt-8 border-t border-base-300 text-sm text-base-content/70"
      >
        <a routerLink="/terms" class="hover:text-primary transition-colors"
          >Terms and Conditions</a
        >
        <span class="text-base-content/20">|</span>
        <a routerLink="/privacy" class="hover:text-primary transition-colors">Privacy Policy</a>
        <span class="text-base-content/20">|</span>
        <a routerLink="/refund" class="hover:text-primary transition-colors">Refund Policy</a>
        <span class="text-base-content/20">|</span>
        <a routerLink="/zoom-documentation" class="hover:text-primary transition-colors">Zoom Integration Docs</a>
      </div>
    }

  </div>
</div>
